"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageTemplateSchema = void 0;
const zod_1 = require("zod");
const shared_1 = require("../shared");
exports.MessageTemplateSchema = zod_1.z.object({
    id: shared_1.UUIDSchema,
    name: zod_1.z.string(),
    message: zod_1.z.string(),
    createdAt: shared_1.ISODateTimeSchema,
    updatedAt: shared_1.ISODateTimeSchema,
});
